import {
  Paragraph,
  SizableText,
  ListItem as TamaguiListItem,
  XStack,
  YStack,
} from 'tamagui';
import { ListItemProps } from './list.types';

/**
 * Generic reusable component for list items.
 * Wraps Tamagui's ListItem with custom props for title, icon, and onPress.
 */
export const ListItem = ({
  title,
  titleAfter,
  subtitle,
  iconBefore,
  iconAfter,
  onPress,
  id,
  variant = 'primary',
}: ListItemProps): React.ReactNode => {
  const isPrimary = variant === 'primary';
  const backgroundColor = isPrimary ? '$tertiary50' : '$transparent';
  const pressStyle = isPrimary
    ? { backgroundColor: onPress ? '$tertiary' : undefined }
    : { backgroundColor: onPress ? '$tertiary50' : undefined };
  const hoverStyle = isPrimary
    ? { backgroundColor: onPress ? '$tertiary75' : undefined }
    : { backgroundColor: onPress ? '$tertiary25' : undefined };
  const borderWidth = isPrimary ? undefined : 1;
  const borderColor = isPrimary ? undefined : '$secondary25';

  return (
    <TamaguiListItem
      key={id}
      iconAfter={iconAfter}
      onPress={onPress}
      cursor={onPress ? 'pointer' : undefined}
      backgroundColor={backgroundColor}
      pressStyle={pressStyle}
      hoverStyle={hoverStyle}
      borderWidth={borderWidth}
      borderColor={borderColor}
    >
      <XStack gap="$true" paddingVertical="$2">
        {iconBefore}
        <YStack gap="$1">
          <XStack alignItems="center" flexWrap="wrap" gap="$2">
            <Paragraph>{title}</Paragraph>
            {titleAfter}
          </XStack>
          {subtitle ? (
            <SizableText size="$2" color="$secondary75">
              {subtitle}
            </SizableText>
          ) : null}
        </YStack>
      </XStack>
    </TamaguiListItem>
  );
};
